function initializeQuickView() {

    const sidebar = document.getElementById('sidebar');

    document.addEventListener("click", function(event) {
        if (sidebar.classList.contains('open') && !sidebar.contains(event.target)) {
            closeSidebar();
        } else if (event.target.classList.contains('sidebar_closebutton')) {
            closeSidebar();
        }
    });

    function closeSidebar() {
        sidebar.classList.remove('open');
        document.querySelector('body').classList.remove("mobile-overflow-hidden");
    }

    const quickViewButtons = document.querySelectorAll('.quick-view-button');

    quickViewButtons.forEach(function(button) {
        button.addEventListener('click', async function(event) {
            event.preventDefault();

            const productHandle = button.getAttribute('data-product-handle');

            try {
                const response = await fetch(`/products/${productHandle}.js`);

                if (!response.ok) {
                    throw new Error('Failed to fetch product data');
                }

                const productData = await response.json();
                const variants = productData.variants;
                const productDescription = productData.description;
                const productVendor= productData.vendor;
                const productTitle = productData.title;
                const productId = productData.id;
                const productPrice= productData.price;

                const parser = new DOMParser();
                const productDescriptionDOM = parser.parseFromString(productDescription, 'text/html');
                const ulElement = productDescriptionDOM.querySelector('ul');
                
                let clonedUlElementHTML = '';
                
                if (ulElement) {
                    const liElements = ulElement.querySelectorAll('li');
                    const firstFourLiElements = Array.from(liElements).slice(0, 4);

                    const tempDiv = document.createElement('div');
                    firstFourLiElements.forEach(li => {
                        tempDiv.appendChild(li.cloneNode(true));
                    });

                    clonedUlElementHTML = tempDiv.innerHTML;
                } else {
                }

                const firstImageSrc = productData.images[0];

                function isMobileViewport() {
                    return window.innerWidth <= 768;
                }

                let variantOptionsHTML;

                if (variants.length > 8) {
                    variantOptionsHTML = `
                    <div class="sidebar_dropdown_button">
                        <select class="sidebar_dropdown_select" id="sidebar_dropdown_variant">
                        <option value="" selected disabled>Select size</option>
                            ${variants.map(variant => {
                                if (variant.available) {
                                    return `<option name="variant" value="${variant.id}">${variant.title}</option>`;
                                } else {
                                    return `<option name="variant" value="${variant.id}" disabled>${variant.title} (Sold Out)</option>`;
                                }
                            }).join('')}
                        </select>
                    </div>
                    `;
                } else {
                    variantOptionsHTML = `
                    <div id="sidebar_variantradios">
                        ${variants.map(variant => {
                            if (variant.available) {
                                return `
                                    <div class="sidebar_size">
                                        <input type="radio" name="variant" value="${variant.id}" id="variant_${variant.id}">
                                        <label for="variant_${variant.id}">${variant.title}</label>
                                    </div>
                                `;
                            } else {
                                return `
                                    <div class="sidebar_size sidebar_size--disabled">
                                        <input type="radio" name="variant" value="${variant.id}" id="variant_${variant.id}" disabled>
                                        <label for="variant_${variant.id}">${variant.title}</label>
                                    </div>
                                `;
                            }
                        }).join('')}
                    </div>
                `;
                }

                const addToCartFormHTML = `
                <div class="sidebar_container_closebutton">
                    <svg
                        class="sidebar_closebutton"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none">
                        <line
                        x1="1.53033"
                        y1="1.46967"
                        x2="23.5303"
                        y2="23.4697"
                        stroke="black"
                        stroke-width="1.5" />
                        <line
                        x1="1.46967"
                        y1="23.4697"
                        x2="23.4697"
                        y2="1.46967"
                        stroke="black"
                        stroke-width="1.5" />
                    </svg>
                </div>
                <div class="sidebar_productimages">
                    <img src="${firstImageSrc}" loading="lazy" alt="${productVendor} ${productTitle}">
                </div>
                <div class="sidebar_productdetails">
                    <a href="/products/${productHandle}">
                        <h2 class="sidebar_producttitle product-main-title">${productVendor} ${productTitle}</h2>
                    </a>
                    <ul>
                    ${clonedUlElementHTML}
                    </ul>
                    <form class="add-to-cart-form" action="/cart/add" method="post">
                        <input type="hidden" name="id" value="${productId}">
                        ${variantOptionsHTML}
                        <input type="number" id="sidebar_quantity" name="quantity" value="1" min="1">
                        <div class="sidebar_container_cartbutton">
                            <button type="submit" class="add-to-cart-button sidebar_cartbutton button-2">Add to Cart</button>
                        </div>
                    </form>
                </div>
            `;

                sidebar.innerHTML = addToCartFormHTML;
                sidebar.classList.add('open');
                document.querySelector('body').classList.add("mobile-overflow-hidden");

                const addToCartForm = sidebar.querySelector('.add-to-cart-form');
                addToCartForm.addEventListener('submit', async function(event) {
                    event.preventDefault();

                    let variantId;

                    if (variants.length > 8) {
                        variantId = addToCartForm.querySelector('#sidebar_dropdown_variant').value;
                    } else {
                        const selectedVariantInput = addToCartForm.querySelector('input[name="variant"]:checked');
                        if (!selectedVariantInput) {
                            console.error('Error: No variant selected');
                            return;
                        }
                        variantId = selectedVariantInput.value;
                    }

                    const quantity = addToCartForm.querySelector('#sidebar_quantity').value;

                    let formData = {
                        'items': [{
                            'id': variantId,
                            'quantity': quantity
                        }]
                    };

                    const config = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(formData)
                    };

                    try {
                        const response = await fetch("/cart/add.js", config);
                        if (!response.ok) {
                            throw new Error('Failed to add product to cart');
                        }
                        const responseData = await response.json();
                        if (responseData.status) {
                            console.error('Error:', responseData.description);
                        } else {
                            sidebar.classList.remove('open');
                            document.querySelector('body').classList.remove("mobile-overflow-hidden");
                            document.body.classList.add("open-drawer");
                            // document.querySelector(".add_cart_message").classList.add("active");
                            // setTimeout(function(e){
                            //     document.querySelector(".add_cart_message").classList.remove("active");
                            // },4000);
                            load_cart();
                        }
                    } catch (error) {
                        console.error('Error:', error);
                    }
                });

            } catch (error) {
                console.error('Error:', error);
            }
        });
    });
};